<mat-card style="padding: 0; height: 100%">
  <div *ngIf="env" id="webchat-root" style="position: relative; width: 100%; height: 100%" data-portal="true"></div>
</mat-card>
